<template>

	<div class="success-bar" v-if="visible" v-on:click="hide">
		<div class="container">
			<div class="icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
				  <circle class="fill-white" cx="20" cy="20" r="20"/>
				  <path class="fill-purple" d="M1598.31,136.515l-10.8,10.8a2.267,2.267,0,0,1-3.02,0l-4.8-4.8a2,2,0,1,1,2.82-2.829l3.49,3.486,9.49-9.486A2,2,0,1,1,1598.31,136.515Z" transform="translate(-1569 -120)"/>
				</svg>
			</div>
			<p>{{ text }}</p>
		</div>
	</div>

</template>
<script>
	 export default {
	 	props: ['message'],
	 	computed: {
	 		text() {
	 			return this.message;
	 		}
	 	},
	 	data: () => ({
	 		visible: false,
        	timer: false
	 	}),
	 	methods: {
	 		hide() {
	 			this.visible = false;
	 		}
	 	},
	 	watch: {
	 		text() {
	 			var self = this;
	 			if (this.text) {
	 				this.visible = true;
	 				this.timer = setTimeout(function() {
	 					self.visible = false;
	 					// If we don't reset the text, changes of repeated messages are not picked up
	 					// self.text = '';
	 				}, 5000);
	 			} else {
	 				clearTimeout(this.timer);
	 				this.visible = false;
	 			}
	 		}
	 	}
    }
</script>
<style></style>
